import { render } from "./InactivePortal.vue?vue&type=template&id=205ae2af&scoped=true"
import script from "./InactivePortal.vue?vue&type=script&lang=js"
export * from "./InactivePortal.vue?vue&type=script&lang=js"

import "./InactivePortal.vue?vue&type=style&index=0&id=205ae2af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-205ae2af"

export default script